import React from 'react';
import { ThumbsUp, MessageCircle, Heart } from 'lucide-react';
const comments = [{
  name: 'María Elena T.',
  initials: 'MT',
  color: 'bg-pink-500',
  time: '2h',
  text: 'Llevo 3 semanas y mi esposo me dijo "¿qué te pasó? la comida está increíble" 😭🙌',
  likes: 47,
  replies: 8,
  reaction: 'love'
}, {
  name: 'Lucía Fernández',
  initials: 'LF',
  color: 'bg-violet-500',
  time: '5h',
  text: 'Yo era la reina del Uber Eats a las 7pm. Esta semana cociné TODAS las cenas. El truco: no tuve que pensar qué hacer.',
  likes: 92,
  replies: 14,
  reaction: 'love'
}, {
  name: 'Paola G.',
  initials: 'PG',
  color: 'bg-blue-500',
  time: '1d',
  text: 'Amiga la que lo está dudando: CÓMPRALO. Son $6.39. Yo gastaba más en un café ☕',
  likes: 134,
  replies: 22,
  reaction: 'like'
}, {
  name: 'Sofía Martínez',
  initials: 'SM',
  color: 'bg-emerald-500',
  time: '1d',
  text: 'El estrés de la cena afecta TODO. Tu humor, tu paciencia, tu sueño. Desde que uso el sistema estoy más tranquila. No exagero.',
  likes: 78,
  replies: 11,
  reaction: 'love'
}, {
  name: 'Diana Morales',
  initials: 'DM',
  color: 'bg-amber-500',
  time: '2d',
  text: 'Mi mamá me llamó para preguntarme cómo organizo tan bien la comida 😂 Le mandé el link.',
  likes: 63,
  replies: 9,
  reaction: 'like'
}, {
  name: 'Camila Reyes',
  initials: 'CR',
  color: 'bg-rose-500',
  time: '2d',
  text: 'Mamá soltera con dos trabajos. 10 minutos el domingo me salvaron la semana entera 💪',
  likes: 201,
  replies: 31,
  reaction: 'love'
}, {
  name: 'Alejandra V.',
  initials: 'AV',
  color: 'bg-indigo-500',
  time: '3d',
  text: 'Pensé que era otro PDF inútil. Pero no. Es un SISTEMA. No te pide creatividad, te pide 10 minutos.',
  likes: 88,
  replies: 15,
  reaction: 'like'
}, {
  name: 'Fernanda López',
  initials: 'FL',
  color: 'bg-teal-500',
  time: '4d',
  text: 'Semana 4: gasté 40% MENOS en comida este mes. Porque dejé de comprar sin plan 🤯',
  likes: 156,
  replies: 27,
  reaction: 'love'
}, {
  name: 'Renata Díaz',
  initials: 'RD',
  color: 'bg-cyan-500',
  time: '4d',
  text: 'Mi hija de 8 años me dijo "mami ya no peleamos por la cena". Eso me rompió el corazón de la mejor manera 🥹',
  likes: 243,
  replies: 35,
  reaction: 'love'
}, {
  name: 'Isabela Ruiz',
  initials: 'IR',
  color: 'bg-orange-500',
  time: '5d',
  text: 'Primer domingo: 10 min planificando. Resultado: 0 estrés de lunes a viernes. CERO. Vale cada centavo.',
  likes: 112,
  replies: 18,
  reaction: 'love'
}, {
  name: 'Natalia Herrera',
  initials: 'NH',
  color: 'bg-lime-600',
  time: '5d',
  text: 'Lo compré escéptica. A la segunda semana mi esposo me preguntó si podía ver el sistema él también para los almuerzos 😂',
  likes: 95,
  replies: 12,
  reaction: 'like'
}, {
  name: 'Claudia Peña',
  initials: 'CP',
  color: 'bg-fuchsia-500',
  time: '6d',
  text: 'Antes: "¿qué hago?" todos los días. Ahora: abro la lista y ejecuto. Así de simple. Así de liberador.',
  likes: 67,
  replies: 7,
  reaction: 'love'
}, {
  name: 'Mónica Salazar',
  initials: 'MS',
  color: 'bg-sky-500',
  time: '1sem',
  text: 'Dejé de sentir culpa por la cena. DEJÉ DE SENTIR CULPA. Eso solo vale los $6.39 y más.',
  likes: 178,
  replies: 24,
  reaction: 'love'
}, {
  name: 'Adriana Castro',
  initials: 'AC',
  color: 'bg-red-400',
  time: '1sem',
  text: 'Mis amigas me preguntan cómo le hago. Les digo: no le hago, el sistema le hace 😎',
  likes: 54,
  replies: 6,
  reaction: 'like'
}, {
  name: 'Jimena Ortiz',
  initials: 'JO',
  color: 'bg-yellow-500',
  time: '1sem',
  text: 'Semana 1 completa. Cociné 5/5 cenas. Nunca en mi vida había logrado eso. Literal nunca.',
  likes: 189,
  replies: 29,
  reaction: 'love'
}, {
  name: 'Karla Mendoza',
  initials: 'KM',
  color: 'bg-green-500',
  time: '1sem',
  text: 'El plan de emergencias me salvó el jueves. Día horrible en el trabajo → cena lista en 15 min sin pensar.',
  likes: 73,
  replies: 10,
  reaction: 'like'
}, {
  name: 'Daniela Vargas',
  initials: 'DV',
  color: 'bg-purple-400',
  time: '2sem',
  text: 'Compré para mí y terminé regalándoselo a mi hermana. Ahora las dos cenamos tranquilas cada noche 🤍',
  likes: 121,
  replies: 16,
  reaction: 'love'
}, {
  name: 'Teresa Romero',
  initials: 'TR',
  color: 'bg-slate-500',
  time: '2sem',
  text: 'No es un recetario. Es paz mental empaquetada en un PDF. Suena exagerado pero es real.',
  likes: 145,
  replies: 20,
  reaction: 'love'
}, {
  name: 'Lorena Ríos',
  initials: 'LR',
  color: 'bg-pink-400',
  time: '2sem',
  text: 'Mi supermercado bajó de $120 a $80 semanal. Compras por bloques = 0 desperdicio. Increíble.',
  likes: 167,
  replies: 23,
  reaction: 'love'
}, {
  name: 'Verónica Gil',
  initials: 'VG',
  color: 'bg-blue-400',
  time: '3sem',
  text: 'A todas las que dicen "no tengo tiempo": yo tampoco. Por eso funciona. Porque son 10 minutos UNA vez.',
  likes: 210,
  replies: 33,
  reaction: 'like'
}];
export default function FacebookCommentsSection() {
  return <div className="py-10 px-4 sm:px-6 lg:px-8 bg-brand-cream-dark" data-id="element-27">
      <div className="max-w-xl mx-auto" data-id="element-28">
        <h3 className="font-heading text-2xl md:text-3xl text-slate-900 text-center mb-1 tracking-wide uppercase" data-id="element-29">
          Lo que dicen en redes
        </h3>
        <p className="text-sm text-slate-400 text-center mb-5" data-id="element-30">
          Comentarios reales de nuestra comunidad
        </p>

        <div className="max-h-[420px] overflow-y-auto space-y-2 pr-1 rounded-lg" style={{
        scrollbarWidth: 'thin'
      }} data-id="element-31">
          {comments.map((c, i) => <div key={i} className="bg-white rounded-lg border border-slate-100 px-3 py-2.5" data-id="element-32">
              <div className="flex gap-2.5" data-id="element-33">
                <div className={`w-7 h-7 ${c.color} rounded-full flex items-center justify-center flex-shrink-0`} data-id="element-34">
                  <span className="text-white text-[10px] font-bold" data-id="element-35">
                    {c.initials}
                  </span>
                </div>
                <div className="flex-1 min-w-0" data-id="element-36">
                  <div className="flex items-center gap-1.5 mb-0.5" data-id="element-37">
                    <span className="font-semibold text-slate-800 text-xs" data-id="element-38">
                      {c.name}
                    </span>
                    <span className="text-[10px] text-slate-400" data-id="element-39">
                      · {c.time}
                    </span>
                  </div>
                  <p className="text-slate-600 text-[13px] leading-relaxed mb-1.5" data-id="element-40">
                    {c.text}
                  </p>
                  <div className="flex items-center justify-between" data-id="element-41">
                    <div className="flex items-center gap-1" data-id="element-42">
                      <div className="flex -space-x-1" data-id="element-43">
                        <div className="w-4 h-4 bg-[#1877F2] rounded-full flex items-center justify-center border border-white" data-id="element-44">
                          <ThumbsUp size={8} className="text-white fill-white" data-id="element-45" />
                        </div>
                        {c.reaction === 'love' && <div className="w-4 h-4 bg-red-500 rounded-full flex items-center justify-center border border-white" data-id="element-46">
                            <Heart size={8} className="text-white fill-white" data-id="element-47" />
                          </div>}
                      </div>
                      <span className="text-[10px] text-slate-400" data-id="element-48">
                        {c.likes}
                      </span>
                    </div>
                    <div className="flex items-center gap-3 text-[10px] text-slate-400" data-id="element-49">
                      <span className="flex items-center gap-0.5" data-id="element-50">
                        <ThumbsUp size={9} data-id="element-51" /> Me gusta
                      </span>
                      <span className="flex items-center gap-0.5" data-id="element-52">
                        <MessageCircle size={9} data-id="element-53" /> {c.replies}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}